<template>
<div>
  <v-card>
    <v-card-title class="title">
      {{ title }}
    </v-card-title>
    <v-progress-circular v-if="chartLoading" :size="70" :rotate="30" :width="5" class="loading-circle" indeterminate></v-progress-circular>
    <apex-chart v-else type="bar" :options="options" :series="series"></apex-chart>
  </v-card>
</div>
</template>

<script>
import apexcharts from 'vue-apexcharts'

export default {
  components: {
    'apex-chart': apexcharts
  },
  props: ['dateFrom', 'dateTo', 'categories', 'series', 'title', 'id'],
  data() {
    return {
      chartLoading: false,
      chartData: []
    }
  },
  computed: {
    options() {
      return {
        chart: {
          toolbar: {
            show: false
          },
          stacked: true,
          stackType: '100%'
        },
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
        xaxis: {
          categories: this.categories ? this.categories : []
        },

        dataLabels: {
          enabled: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        yaxis: {
          labels: {
            show: true
          }
        },

      }
    }
  },
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}
</style>
